import { toast } from "react-toastify";
import { axiosUnauthInstance } from "../../service/API";

export const handleCreateDeveloper = (payload) => {
    return async (dispatch) => {
        try {
            const { status, data } = await axiosUnauthInstance.post('/developer/', payload);
            if (status === 201) toast.success(data?.message);
            return status;
        } catch (error) {
            console.log(error);
            toast.error(error.message);
        }
    }
}
